import humanFormat from 'human-format';

const numberScale = new humanFormat.Scale({
  '': 1,
  k: 1_000,
  M: 1_000_000,
  B: 1_000_000_000,
  T: 1_000_000_000_000,
  q: 1_000_000_000_000_000,
  Q: 1_000_000_000_000_000_000,
  s: 1_000_000_000_000_000_000_000,
  S: 1_000_000_000_000_000_000_000_000,
});

/** Time unit labels per language (scale key = displayed unit). */
const timeScales: Record<string, humanFormat.Scale<string>> = {
  en: new humanFormat.Scale({
    seconds: 1,
    minutes: 60,
    hours: 3600,
    days: 86400,
    months: 2592000,
  }),
  fr: new humanFormat.Scale({
    secondes: 1,
    minutes: 60,
    heures: 3600,
    jours: 86400,
    mois: 2592000,
  }),
  pt: new humanFormat.Scale({
    segundos: 1,
    minutos: 60,
    horas: 3600,
    dias: 86400,
    meses: 2592000,
  }),
  de: new humanFormat.Scale({
    Sekunden: 1,
    Minuten: 60,
    Stunden: 3600,
    Tage: 86400,
    Monate: 2592000,
  }),
};

const defaultTimeScale = timeScales.en;

export const humanNumber = (value: number, maxDecimals: number = 2) => {
  return humanFormat(value, { scale: numberScale, separator: '', maxDecimals });
};

/**
 * Format a duration (in seconds) in human-readable form.
 * @param time - Duration in seconds
 * @param lang - Language code for unit labels: 'en' | 'fr' | 'pt' | 'de' (default 'en')
 */
export const humanTime = (
  time: number,
  lang: string = 'en',
): { value: number; prefix: string } => {
  const scale = timeScales[lang] ?? defaultTimeScale;
  return humanFormat.raw(time, { scale, maxDecimals: 2 });
};
